// This function should be dropped as soon as our bundler supports Promise.withResolvers
// @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
export function createControlledPromise<T extends void>(): Promise<T> & {
  resolve: (value: T) => T;
  reject: () => never;
} {
  let resolve;
  let reject;

  const promise = new Promise<T>((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });

  return Object.assign(promise, { resolve, reject });
}
